import { render, staticRenderFns } from "./AsyncComponent.vue?vue&type=template&id=adea51a0"
import script from "./AsyncComponent.vue?vue&type=script&lang=js"
export * from "./AsyncComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports